import type { AtualizarFornecedorDto, CriarFornecedorDto, FornecedorResponse, ListarFornecedoresQuery } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/** Fornecedores da empresa (GET /fornecedores): `custo.ver`. Sem a permissao a API responde 403; a tela nao consulta. */
export function useFornecedores(q: Partial<ListarFornecedoresQuery> = {}, opts: { ativo?: boolean } = {}) {
  return useConsulta<FornecedorResponse[]>(['fornecedores'], '/fornecedores', { query: q, ...(opts.ativo === undefined ? {} : { ativo: opts.ativo }) });
}

/** Um fornecedor (GET /fornecedores/:id): o formulario da tela carrega por ele, mesmo que a lista filtrada nao o traga. */
export function useFornecedor(id: string | undefined) {
  return useConsulta<FornecedorResponse>(['fornecedores', id], `/fornecedores/${id}`, { ativo: !!id });
}

/** Cria fornecedor: com `parceiroId` usa o parceiro ja existente (sem nome). Invalida clientes: o papel aparece la tambem. */
export function useCriarFornecedor() {
  return useMutacao<FornecedorResponse, CriarFornecedorDto>({
    metodo: 'POST', caminho: () => '/fornecedores', corpo: (v) => v, invalidar: [['fornecedores'], ['clientes']],
  });
}

export function useAtualizarFornecedor() {
  return useMutacao<FornecedorResponse, { id: string } & AtualizarFornecedorDto>({
    metodo: 'PATCH',
    caminho: (v) => `/fornecedores/${v.id}`,
    corpo: ({ id: _id, ...resto }) => resto,
    invalidar: [['fornecedores']],
  });
}
